'use client'

import React, { ReactNode, useMemo } from 'react'

import { useQuery } from '@apollo/client'

import StyleSheetProvider from 'app/styleSheetProvider'

import { MeDocument } from 'GraphQL/Main/TypedDocuments'

import { AppContext } from 'Services/AppContext'
import { useSession } from 'Services/Store/Session'

import { ThemeProvider } from 'Theme'

export function Providers({ children }: { children: ReactNode }) {
  const { isAuthorized } = useSession()

  const { data: meData, loading: meLoading } = useQuery(MeDocument, {
    skip: !isAuthorized,
  })

  const appContextValue = useMemo(
    () => ({
      me: meData?.me,
      meLoading,
    }),
    [meData, meLoading],
  )

  return (
    <StyleSheetProvider>
      <ThemeProvider>
        <AppContext.Provider value={appContextValue}>
          {children}
        </AppContext.Provider>
      </ThemeProvider>
    </StyleSheetProvider>
  )
}
